export default "__VITE_ASSET__D67Z5Aqs__"